"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _shortid = _interopRequireDefault(require("shortid"));

var _propTypes = require("prop-types");

var _react = require("react");

var _Layers = _interopRequireDefault(require("@material-ui/icons/Layers"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Logo = _interopRequireDefault(require("../Logo/Logo"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _ButtonNew = _interopRequireDefault(require("../ButtonNew/ButtonNew"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: 1rem;\n    @media (min-width: 500px) {\n      display: none;\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 0.8rem;\n    margin: -10px 0px 0px 31px;\n    font-style: italic;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: 2rem;\n    margin: auto;\n    text-align: center;\n    font-family: \"Roboto Condensed\", \"Helvetica Neue\", Helvetica, sans-serif;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    height: 250px;\n    width: 100%;\n    margin: auto;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SandboxDrawerLayerSelector = function SandboxDrawerLayerSelector(props) {
  var onChange = props.onChange,
      foundationData = props.foundationData,
      allSlides = props.allSlides,
      areSlidesLoading = props.areSlidesLoading,
      errors = props.errors,
      updateSlideKey = props.updateSlideKey,
      selectedPackage = props.selectedPackage,
      toggleDrawer = props.toggleDrawer;
  var loadingContainer = (0, _core.css)(_templateObject());
  var loading = (0, _core.css)(_templateObject2());
  var scatterplotHelperText = (0, _core.css)(_templateObject3());
  var mobileOnly = (0, _core.css)(_templateObject4());
  var loader = (0, _core.jsx)("div", {
    css: loadingContainer
  }, (0, _core.jsx)("div", {
    css: loading
  }, (0, _core.jsx)(_Logo["default"], {
    type: "squareLogoAnimated",
    alt: "Loading..."
  })));
  return (0, _core.jsx)(_react.Fragment, null, (0, _core.jsx)("div", {
    css: (0, _core.css)("\n            position: relative;\n            z-index: 900;\n          ")
  }, (0, _core.jsx)("div", {
    css: (0, _core.css)("margin: 0 10px;")
  }, (0, _core.jsx)("h2", null, (0, _core.jsx)(_Layers["default"], {
    fontSize: "large",
    css: (0, _core.css)("\n                vertical-align: middle;\n              ")
  }), "Map Layers"), (0, _core.jsx)("h3", null, selectedPackage), (0, _core.jsx)("div", {
    css: mobileOnly
  }, (0, _core.jsx)(_ButtonNew["default"], {
    label: "View Map",
    onClick: toggleDrawer
  })))), (0, _core.jsx)("div", {
    css: (0, _core.css)("\n            position: relative;\n            z-index: 200;\n          ")
  }, (0, _core.jsx)("h3", {
    css: (0, _core.css)("\n              color: #555;\n              text-transform: uppercase;\n              margin: 0 10px;\n            ")
  }, "Layers")), !areSlidesLoading && allSlides ? allSlides.map(function (slide, index) {
    var dataIndex = foundationData.findIndex(function (d) {
      var scatterplot = d.mapType === "ScatterPlotMap" && d.layerInfo.displayName === slide.label;
      var choropleth = d.mapType === "ChoroplethMap" && d.layerInfo.displayName === slide.label;
      return choropleth || scatterplot;
    });
    var matchFound = dataIndex > -1 && foundationData[dataIndex].data.length > 0;
    var keyAllOptions = matchFound ? Object.keys(foundationData[dataIndex].data[0].properties).filter(function (c) {
      var fieldName = foundationData[dataIndex].fieldName.color;
      var a = c.match(/^[a-zA-Z]+/);
      var b = fieldName.match(/^[a-zA-Z]+/);
      return a[0] === b[0];
    }) : [];
    var keyOptions = keyAllOptions.length > 3 ? keyAllOptions.slice(0, 4) : keyAllOptions;
    var censusYears = ["1990", "2000", "2010", "2017"];
    var censusChangeYears = ["1990-2017", "2000-2017", "2010-2017"];
    var notYear = keyAllOptions[0] && keyAllOptions[0].search(/[0-9]/) > -1;
    var keySelector = matchFound && notYear && (0, _core.jsx)(_Dropdown["default"], {
      value: foundationData[dataIndex].fieldName.color,
      options: keyOptions.length === 3 ? keyOptions.map(function (k, i) {
        return {
          value: k,
          label: censusChangeYears[i]
        };
      }) : keyOptions.map(function (k, i) {
        return {
          value: k,
          label: censusYears[i]
        };
      }),
      onChange: function onChange(name) {
        updateSlideKey(_defineProperty({}, slide.label, name));
      },
      simpleValue: true
    });
    return (0, _core.jsx)("div", {
      key: _shortid["default"].generate()
    }, (0, _core.jsx)("div", {
      css: (0, _core.css)("\n                    padding: 0.5rem 0 0 1rem;\n                  ")
    }, (0, _core.jsx)(_Checkbox["default"], {
      name: slide.label,
      value: slide.checked,
      onChange: onChange,
      label: slide.label
    }), slide.mapType === "vtScatterPlotMap" ? (0, _core.jsx)("div", {
      css: scatterplotHelperText
    }, "Zoom in to view") : ""), (0, _core.jsx)("div", {
      css: (0, _core.css)("\n                    padding: 0;\n                    font-size: .75rem;\n                    color: #333;\n                    position: relative;\n                    z-index: ".concat(10 - index, ";\n                  "))
    }, keySelector));
  }) : loader, errors ? (0, _core.jsx)("div", {
    css: (0, _core.css)("\n                margin: auto;\n                width: 80%;\n              ")
  }, (0, _core.jsx)("p", null, "There was an error fetching the data.")) : null);
};

var _default = SandboxDrawerLayerSelector;
exports["default"] = _default;
SandboxDrawerLayerSelector.propTypes = {
  onChange: _propTypes.func,
  foundationData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  allSlides: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  areSlidesLoading: _propTypes.bool,
  errors: _propTypes.bool,
  updateSlideKey: _propTypes.func,
  selectedPackage: _propTypes.string,
  toggleDrawer: _propTypes.func
};